export { default } from './Footer';

require('./footer.scss');